import React, { useRef, useEffect } from "react";
import { Typography, Box, useTheme, Button } from "@mui/material";
import Header from "../../components/Header";
//import RealTimeClock from "../../components/Time";
import {useNavigate, useParams} from "react-router-dom";
import { cobotColours } from "../../theme/theme";
import api from "../../services/api";

const ClockInPhoto = () => {
    const cobotTheme = useTheme();
    const colors = cobotColours(cobotTheme.palette);
    const Navigate  = useNavigate();
    const { id } = useParams();

    const videoRef = useRef(null);
    const canvasRef = useRef(null);

    useEffect(() => {
        // Access the camera when the component mounts
        const getCameraStream = async () => {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: true,
                });
                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                }
            } catch (error) {
                console.error("Error accessing camera:", error);
            }
        };

        getCameraStream();

        // Cleanup function to stop the camera when unmounting
        return () => {
            const video = videoRef.current;
            if (video && video.srcObject) {
                const stream = video.srcObject;
                const tracks = stream.getTracks();
                tracks.forEach(track => track.stop());
            }
        };
    }, []);

    const capturePhoto = async () => {
        if (videoRef.current && canvasRef.current) {
            const context = canvasRef.current.getContext("2d");
            context.drawImage(videoRef.current, 0, 0, canvasRef.current.width, canvasRef.current.height);
        }

        // Stop the camera after capture
        if (videoRef.current && videoRef.current.srcObject) {
            const stream = videoRef.current.srcObject;
            const tracks = stream.getTracks();
            tracks.forEach(track => track.stop());
            videoRef.current.srcObject = null; // Remove video stream
        }

        try {
            // Call the clock-in API
            const data = await api.employee.clockIn(id);

            if (data.success) {
                // console.log("Clocked in successfully");
                // Navigate after successful clock-in
        Navigate(`/EmployeeClockedIn/${id}`);
            } else {
                // Handle clock-in failure (e.g., already clocked in, server error)
                console.error("Clock-in failed:", data.message);
                // Optionally, display an error message to the user
                // alert(`Clock-in failed: ${data.message}`);
                // Navigate to an error page or back to PIN entry, as appropriate
                Navigate(`/LoginPage/${id}`); // Example: Navigate back to PIN page
            }
        } catch (error) {
            console.error("Error during clock-in process:", error);
            // alert("An error occurred. Please try again.");
            Navigate(`/LoginPage/${id}`); // Example: Navigate back to PIN page on network error
        }
    };

    return (
        <Box
            height="100vh"
            display="flex"
            flexDirection="column"
            backgroundColor={colors.primary.special}
            padding={2}
        >
            {/* Header Section */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                textAlign="center"
                backgroundColor={colors.primary.teal}
            >
                <Header title="CLOCK IN" />
            </Box>

            {/* Main Content */}
            <Box
                flex={1}
                display="flex"
                padding="10px 0"
                gap={2}
            >
                {/* Left Panel
                <Box
                    width={{ xs: "100%", md: "25%" }}
                    display="flex"
                    flexDirection="column"
                    gap={2}
                >
                    <Box
                        width="100%"
                        height="100px"
                        borderRadius="10px"
                        backgroundColor={colors.grey.lighter}
                        display="flex" justifyContent="center"
                        alignItems="center"
                    >
                        <RealTimeClock />
                    </Box>
                </Box>
                */}

                {/* Right Panel */}
                <Box
                    flex={1}
                    display="flex"
                    flexDirection="column"
                    gap={2}
                >
                    {/* Camera Section */}
                    <Box
                        justifyContent="center" display="flex"
                    >
                        {/* Live Video Feed */}
                        <video ref={videoRef} autoPlay playsInline style={{ width: "50%", borderRadius: "10px" }}></video>

                    </Box>

                    <Box justifyContent="center" display="flex">
                        {/* Canvas to Display Captured Image
                        <canvas ref={canvasRef} width="100" height="200" style={{ display: "flex" }}></canvas>
                        */}
                    </Box>

                    <Box justifyContent="center" display="flex">
                        <Typography >
                            Please align your face to the frame
                        </Typography>
                    </Box>

                    <Box display="flex" justifyContent="center">
                        {/* Capture Button */}
                        <Button variant="contained" color="primary" onClick={capturePhoto}>
                            Capture Photo
                        </Button>
                    </Box>

                </Box>
            </Box>
        </Box>
    );
};

export default ClockInPhoto;